import { Languages, LogOut, Settings, Sparkles } from 'lucide-react';
import { useFeatureFlagEnabled } from 'posthog-js/react';

import {
  AssistantIcon,
  DataManagementIcon,
  EsgIcon,
  GoalAndActionIcon,
  HomeIcon,
  MaterialityAssessmentIcon,
  ReportIcon,
} from '@/modules/common/components/icons';

import { AccessScope, FeatureFlag, UserRole } from '../types';
import { useUser } from './context/user';

const useSidebarNavigation = () => {
  const isAssistantEnabled = useFeatureFlagEnabled(FeatureFlag.ASSISTANT);

  const { isDeactivated } = useUser();

  const getMainNavigation = () => {
    const mainMenuItems = isDeactivated
      ? []
      : [
          {
            label: 'shared.standards.home',
            to: '/',
            allowedRoles: [UserRole.ADMIN, UserRole.VIEWER],
            accessScope: [AccessScope.UNLIMITED, AccessScope.MATERIALITY],
            Icon: HomeIcon,
          },
          {
            label: 'shared.standards.materialityAssessment',
            to: '/materiality-assessment',
            allowedRoles: [UserRole.ADMIN, UserRole.VIEWER],
            accessScope: [AccessScope.UNLIMITED, AccessScope.MATERIALITY],
            Icon: MaterialityAssessmentIcon,
          },
          {
            label: 'shared.standards.dataManagement',
            to: '/data-management',
            allowedRoles: [UserRole.ADMIN, UserRole.EMPLOYEE, UserRole.VIEWER],
            accessScope: [AccessScope.UNLIMITED],
            Icon: DataManagementIcon,
          },
          {
            label: 'shared.standards.analysis',
            to: '/analysis',
            allowedRoles: [UserRole.ADMIN, UserRole.EMPLOYEE, UserRole.VIEWER],
            accessScope: [AccessScope.UNLIMITED],
            Icon: EsgIcon,
          },
          {
            label: 'shared.standards.goalAndAction',
            to: '/goal-action',
            allowedRoles: [UserRole.ADMIN, UserRole.EMPLOYEE, UserRole.VIEWER],
            accessScope: [AccessScope.UNLIMITED],
            Icon: GoalAndActionIcon,
          },
        ];

    if (!isDeactivated) {
      mainMenuItems.push({
        label: 'shared.standards.reporting',
        to: '/reports',
        allowedRoles: [UserRole.ADMIN, UserRole.EMPLOYEE, UserRole.VIEWER],
        accessScope: [AccessScope.UNLIMITED],
        Icon: ReportIcon,
      });
    }

    if (isAssistantEnabled && !isDeactivated) {
      mainMenuItems.push({
        label: 'shared.standards.assistant',
        to: '/assistant',
        allowedRoles: [UserRole.ADMIN, UserRole.EMPLOYEE],
        accessScope: [AccessScope.UNLIMITED, AccessScope.MATERIALITY],
        Icon: AssistantIcon,
      });
    }
    return mainMenuItems;
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const getBottomNavigation = (actions: any[] | undefined = undefined) => {
    return [
      {
        label: 'shared.standards.mavue2',
        handleClick: actions && actions.length > 0 ? actions[3] : null,
        Icon: Sparkles,
        dataCy: 'action-mavue2',
      },
      {
        label: 'shared.standards.settings',
        handleClick: actions && actions.length > 0 ? actions[0] : null,
        Icon: Settings,
        dataCy: 'action-settings',
      },
      {
        label: 'shared.standards.language',
        handleClick: actions && actions.length > 0 ? actions[1] : null,
        Icon: Languages,
        dataCy: 'action-language',
      },
      {
        label: 'shared.standards.logout',
        Icon: LogOut,
        handleClick: actions && actions.length > 2 ? actions[2] : null,
        dataCy: 'action-logout',
      },
    ];
  };

  return { getMainNavigation, getBottomNavigation };
};

export default useSidebarNavigation;
